(function () {
    var HomeChargesCtrl = (function () {
        function HomeChargesCtrl() {
            this.init.apply(this, arguments);
        }

        HomeChargesCtrl.prototype = {
            init: function ($scope, $state, $rootScope, $stateParams, localStorageService, $mdDialog, $ionicScrollDelegate, $timeout, MKioskService, $message, $q) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.localStorageService = localStorageService;
                this.$mdDialog = $mdDialog;
                this.$ionicScrollDelegate = $ionicScrollDelegate;
                this.$timeout = $timeout;
                this.MKioskService = MKioskService;
                this.$message = $message;
                this.$q = $q;

                this.loadData().then(angular.bind(this, function (list) {
                    // NF-724: Adapt translation as origial server result by En 
                    for(var d of list) {
                        // NF-890: With special value, we need to translate the text
                        if (d.Name === 'lbConsumptionsForOngoingPeriod') {
                            d.EventId = 'OnGoing';
                            d.Name = this.$message.get('lbConsumptionsForOngoingPeriod')
                        } else {
                            d.Name =  moment(d.Name, 'MMMM YYYY', 'en')
                            .locale(moment.locale())
                            .format('MMMM YYYY');
                        }
                    }
                    
                    this.list = list;
                }));
            },

            back: function () {
                this.$state.go("internal.home");
            },
            loadData: function () {
                return this.MKioskService.getHomeCharges();
            },
            gotoEvent: function (item) {
                if(item.EventId) {
                    if (item.EventId === 'OnGoing') {
                        this.$state.go("internal.on-going");
                    } else {
                        this.$state.go("internal.eventdetail", {
                            id: item.EventId,
                            prevState: "internal.homecharges",
                            title: item.Name
                        });
                    }
                    
                }
            }
        };
        HomeChargesCtrl.$inject = ['$scope', '$state', '$rootScope', '$stateParams', 'localStorageService', '$mdDialog', '$ionicScrollDelegate', '$timeout', 'MKioskService', '$message', '$q'];
        return HomeChargesCtrl;
    }());
    angular.module('internal.homecharges').controller('HomeChargesCtrl', HomeChargesCtrl)
})();


